import { AnyAction } from 'redux';

import {
    FOOTER_SETTINGS_ERROR,
    RECEIVE_FOOTER_SETTINGS,
    REQUEST_FOOTER_SETTINGS,
    UPDATE_FOOTER_LINKS,
} from './footer-settings-actions';
import { FooterSettings } from '../models/footer-settings';

export interface FooterSettingsReducerState {
    links: FooterSettings | null;
    requesting: boolean;
}

const initialFooterSettingsReducerState: FooterSettingsReducerState = {
    links: null,
    requesting: false,
};

export const footerSettingsReducer = (
    state: FooterSettingsReducerState = initialFooterSettingsReducerState,
    action: AnyAction
): FooterSettingsReducerState => {
    switch (action.type) {
        case REQUEST_FOOTER_SETTINGS: {
            return {
                ...state,
                requesting: true,
            };
        }

        case FOOTER_SETTINGS_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case UPDATE_FOOTER_LINKS:
        case RECEIVE_FOOTER_SETTINGS: {
            return {
                ...state,
                links: action['links'],
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
